var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 13 15.7445",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 3.42857,
    cy: 3.42857,
    r: 3.42857,
    transform: "matrix(-1 0 0 1 9.92857 0.5)",
    stroke: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M0.5 12.444C0.5 11.7066 0.963589 11.0487 1.65808 10.8007C4.78918 9.68244 8.21082 9.68244 11.3419 10.8007C12.0364 11.0487 12.5 11.7066 12.5 12.444V13.5716C12.5 14.5894 11.5985 15.3712 10.591 15.2273L10.255 15.1793C7.76432 14.8235 5.23568 14.8235 2.74497 15.1793L2.40904 15.2273C1.40146 15.3712 0.5 14.5894 0.5 13.5716V12.444Z",
    stroke: "#F1F1F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.7baa49b3d590c6e37c8002ab59c392fe.svg";
export { ForwardRef as ReactComponent };